export default {"src":"/_next/static/media/unavailable.46b43baa.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};